import { ReactNode, useState } from 'react';
import { PaginatedTable } from 'src/components/organisms';
import { AuditEntryType } from 'src/graphql';
import { Modal } from '../Modal';
import { ColumnType } from '../TableRow';

interface Props {
  auditLogEntries: AuditEntryType[];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  columns: ColumnType[];
  tableDataCallback: (entry: AuditEntryType) => {
    cellData: (string | ReactNode)[];
    row: string;
  };
  emptyText?: string;
}

export const AuditLogTable = ({
  auditLogEntries,
  isOpen,
  setIsOpen,
  columns,
  tableDataCallback,
  emptyText = 'No audit log entries.',
}: Props) => {
  const entriesPerPage = 10;
  const numPages = Math.ceil(auditLogEntries?.length / entriesPerPage);
  const [currentPage, setCurrentPage] = useState(1);

  // Function to handle page change
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the current entries to display
  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = auditLogEntries?.slice(
    indexOfFirstEntry,
    indexOfLastEntry,
  );

  // Prepare table data format
  const tableData = currentEntries?.map((entry) => tableDataCallback(entry));

  return (
    <Modal
      size="large"
      title="Audit Log"
      open={isOpen}
      setOpen={setIsOpen}
      onCancel={() => setIsOpen(false)}
      hideButtons={true}
      data-testid="audit-log-modal"
    >
      <PaginatedTable
        columns={columns}
        tableData={tableData}
        numPages={numPages}
        currentPage={currentPage}
        handleClickPage={handlePageChange}
        showPagination={true}
        visibleColumns={columns}
        sortableColumns={[]}
        data-testid="audit-log-table"
        fixedRowHeight={true}
        isFullWidth={true}
        emptyText={emptyText}
      />
    </Modal>
  );
};
